/*
 * Module for the Irs1099R RePrint view
 */
rs.module("content/participant/benefits/irs1099r/reprint",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {
        
        // Initialize the page
        function initialize(jsSelectors) {

            // Unpack js selectors
            var reprintForm = $.js(jsSelectors.reprintForm);
            var formTypeSelect = reprintForm.js(jsSelectors.formType);
            var xOffsetTextbox = reprintForm.js(jsSelectors.xOffset);
            var yOffsetTextbox = reprintForm.js(jsSelectors.yOffset);

            // Listen for form type select changes
            formTypeSelect.change(enableDisableFields);

            // Enable or disable alignment fields based on whether or not a Pre-Printed form is selected
            function enableDisableFields() {

                var isPrePrinted = formTypeSelect.find(":selected").text().toUpperCase().includes("PRE-PRINTED");

                xOffsetTextbox.prop("disabled", !isPrePrinted).clearErrors();
                yOffsetTextbox.prop("disabled", !isPrePrinted).clearErrors();
                if (!isPrePrinted) {
                    xOffsetTextbox.val('');
                    yOffsetTextbox.val('');
                }

                // Clear event banner
                eventBanner.removeAllMessages();
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);